import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { ItemId, Organization } from '../../../types/items';

export const initOrganizationRequest = action(
  'INIT_ORGANIZATION_REQUEST',
  withoutPayload,
);

export const initOrganizationClear = action(
  'INIT_ORGANIZATION_CLEAR',
  withoutPayload,
);

export const initOrganizationSuccess = action(
  'INIT_ORGANIZATION_SUCCESS',
  withPayload<Organization>(),
);
export const initOrganizationFail = action(
  'INIT_ORGANIZATION_FAIL',
  withoutPayload,
);

export const createOrganizationRequest = action(
  'CREATE_ORGANIZATION_REQUEST',
  withPayload<Organization>(),
);
export const createOrganizationSuccess = action(
  'CREATE_ORGANIZATION_SUCCESS',
  withPayload<Organization>(),
);
export const createOrganizationFail = action(
  'CREATE_ORGANIZATION_FAIL',
  withoutPayload,
);

export const getOrganizationListRequest = action(
  'GET_ORGANIZATION_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getOrganizationListSuccess = action(
  'GET_ORGANIZATION_LIST_SUCCESS',
  withPayload<ItemList<Organization>>(),
);
export const getOrganizationListFail = action(
  'GET_ORGANIZATION_LIST_FAIL',
  withoutPayload,
);

export const setOrganizationListDirty = action(
  'SET_ORGANIZATION_LIST_DIRTY',
  withPayload<boolean>(),
);

export const getOrganizationRequest = action(
  'GET_ORGANIZATION_REQUEST',
  withPayload<ItemId>(),
);
export const getOrganizationSuccess = action(
  'GET_ORGANIZATION_SUCCESS',
  withPayload<Organization>(),
);
export const getOrganizationFail = action(
  'GET_ORGANIZATION_FAIL',
  withoutPayload,
);

export const resetCurrentOrganization = action(
  'RESET_CURRENT_ORGANIZATION',
  withoutPayload,
);

export const saveOrganizationRequest = action(
  'SAVE_ORGANIZATION_REQUEST',
  withPayload<Organization>(),
);
export const saveOrganizationSuccess = action(
  'SAVE_ORGANIZATION_SUCCESS',
  withPayload<Organization>(),
);
export const saveOrganizationFail = action(
  'SAVE_ORGANIZATION_FAIL',
  withoutPayload,
);

export const deleteOrganizationRequest = action(
  'DELETE_ORGANIZATION_REQUEST',
  withPayload<ItemId>(),
);
export const deleteOrganizationSuccess = action(
  'DELETE_ORGANIZATION_SUCCESS',
  withoutPayload,
);
export const deleteOrganizationFail = action(
  'DELETE_ORGANIZATION_FAIL',
  withoutPayload,
);

export const clearOrganizationList = action(
  'CLEAR_ORGANIZATION_LIST',
  withoutPayload,
);
